import { useEffect, useRef, useState } from "react";
import logo from "./assets/Nexus_logo@3x.png";
import logoDark from "./assets/Nexus_logo@3x_Dark.png";
// import logo from "./assets/logo.png";
// import people from "./assets/adminnav-people.png";
import ModalAdminQuickAdd from "./ModalAdminQuickAdd";
import ChangePasswordModal from "./ChangePasswordModal";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import DarkModeToggle from "react-dark-mode-toggle";
import { useLanguage } from "./languageContext";
import LanguageToggle from "./languageToggle";
import translations from "./translation.json";
import { externalUsers, internalUsers, provincesOptions } from "./constants/userTypes";
// import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import { clearLocalStorage } from "./utils/clearLocalStorage";


const AdminNav = ({
  setDisplayComponent,
  dealerships,
  setDealerTrigger,
  setEventTrigger,
  setToken,
  token,
  setIsDarkMode,
  isDarkMode,
  setPrevDisplay,
  setIsLoading,
  events,
  setEvents,
  setDealerships2,
  dealerships3,
  setDealerships3,
  dealerships2,
  getDealershipFilterData,
  showDealerDropDown,
  displayComponent,
  getDealershipFilterDataDealersPage,
  selectedOption,
  setSelectedOption,
  selectedProvince,
  setSelectedProvince,
  dealershipLabel,
  setDealershipLabel,
  selectedOptionRef,
  setCheckedFields,
  checkedFields,
  eventsAccessLocked,
}) => {
  const excludedComponents = [
    "forms",
    "user-profile",
    "create-event",
    "create-privateEvent",
    "edit-event",
    "edit-form",
    "create-user",
    "edit-user",
    "edit-client",
    "view-submissions",
    "dealership",
    "manage-users",
    "view-sales-report",
    "status-report",
    "black-list",
    "agent-bonus-report",
    "bonus-confirmation-report",
  ];
const [provinceLabel, setProvinceLabel] = useState(null);
  const userType = localStorage.getItem("userType");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();
  const pageTranslations = translations["topAndsidebar"];
  const dealershipFilter = JSON.parse(localStorage.getItem("dealershipFilter"));
  const eventsFilterData = JSON.parse(localStorage.getItem("eventsFilterData"));
  const isFirstRender = useRef(true);
  const isFirstRenderProvince = useRef(true);
     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status === "success") {
        clearLocalStorage();
        setToken(null);
        setIsDarkMode(false);
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(translations.alertMessages.wentWrong[language]);
      clearLocalStorage();
      setToken(null);
      setIsDarkMode(false);
    }
  };

  useEffect(() => {
    // Reset the dropdown whenever the URL changes
    const selectedValues = selectedOption?.map((option) => option.value);
    if (displayComponent === "dealership" && selectedValues?.length > 0) {
      if (userType && internalUsers.includes(userType)) {
        getDealershipFilterDataDealersPage(selectedValues || []);
      }
    }
    if (
      displayComponent === "events" &&
      !eventsAccessLocked &&
      selectedValues?.length > 0
    ) {
      getDealershipFilterData(selectedValues || [], selectedProvince ? selectedProvince.map((option) => option.value) : []);
    }
    if (displayComponent === "events") {
      setDealershipLabel(null);
    }
    // setSelectedOption(null);
  }, [displayComponent, eventsAccessLocked]);

  // At the top level of your component

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // ✅ Skip first render
    }

    if (
      !selectedOption ||
      excludedComponents.includes(displayComponent) ||
      checkedFields?.length > 0
    )
      return;

    const callFunctions = async () => {
      setIsLoading(true);
      try {
        const selectedProvinceValues =
          selectedProvince.map((option) => option.value) || [];
        const selectedValues =
          selectedOption.map((option) => option.value) || [];
        let apiCalls = [
          getDealershipFilterData(selectedValues,selectedProvinceValues),
        ];

        if (userType && internalUsers.includes(userType)) {
          apiCalls.push(getDealershipFilterDataDealersPage([]));
        }

        await Promise.all(apiCalls);
      } catch (error) {
        console.error("Error in API calls:", error);
      } finally {
        setIsLoading(false);
      }
    };

    callFunctions();
  }, [selectedOption]);

  useEffect(() => {
    if (isFirstRenderProvince.current) {
      isFirstRenderProvince.current = false;
      return; // ✅ Skip first render
    }

    if (
      !selectedProvince ||
      excludedComponents.includes(displayComponent) ||
      checkedFields?.length > 0
    )
      return;

    const callFunctions = async () => {
      setIsLoading(true);
      try {
        const selectedProvinceValues =
          selectedProvince.map((option) => option.value) || [];
          const selectedValues = selectedOption?.map((option) => option.value);
        let apiCalls = [
          getDealershipFilterData(selectedValues,selectedProvinceValues),
        ];

        if (userType && internalUsers.includes(userType)) {
          apiCalls.push(getDealershipFilterDataDealersPage([]));
        }

        await Promise.all(apiCalls);
      } catch (error) {
        console.error("Error in API calls:", error);
      } finally {
        setIsLoading(false);
      }
    };

    callFunctions();
  }, [selectedProvince]);

  return (
    <div
      className="admin-nav"
      style={{ backgroundColor: isDarkMode ? "#2b3035" : "" }}
    >
      <nav
        id="mainav"
        className="navbar navbar-light bg-light sticky-top"
        style={{ marginBottom: 10, padding: "4px 0" }}
      >
        <div className="container-fluid">
          <div
            className="navbar-brand"
            onClick={() => {
              setDisplayComponent("events");
              window.history.pushState(
                { id: "gallery", randomData: window.Math.random() },
                "title",
                "/event-portal?page=events"
              );
            }}
            style={{ cursor: "pointer" , marginRight:isMobile && '0px'}}
          >
            <img
              id="search-link-logo"
              className="p-1"
              src={isDarkMode ? logoDark : logo}
              alt="Logo"
              height="38"
            />{" "}
            {/* | Nexus <span style={{ fontSize: 15 }}>V6</span> */}
          </div>
          {!isMobile && (
            <div className="d-flex align-items-center gap-2">
              {!excludedComponents.includes(displayComponent) && (
                <>
                <div
                  style={{ width: "250px" }}
                  className={
                    isDarkMode ? "statusDropdownDark" : "statusDropdown"
                  }
                >
                  <>
                    {/* <Select
                  className="w-100 selectpicker"
                  aria-labelledby="dealership-name-quick"
                  isClearable
                  options={dealerships2}
                  placeholder={translations["dropdown"].select[language]}
                  isSearchable={true}
                  // value={
                  //   (dealerships2 &&
                  //     dealerships2.length > 0 &&
                  //     dealerships2.find(
                  //       (option) => option.value === filterOption
                  //     )) || {
                  //     value: "",
                  //     label: translations["dropdown"].select[language],
                  //   }
                  // }
                  value={selectedOption} // Controlled value
                  onChange={(selectedOption) => {
                    setSelectedOption(selectedOption);
                    getDealershipFilterData(
                      selectedOption ? selectedOption.value : ""
                    );
                    getDealershipFilterDataDealersPage("");
                  }}
                  maxMenuHeight={"130px"}
                  styles={{
                    input: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                    }),
                    control: (provided, state) => ({
                      ...provided,
                      backgroundColor: isDarkMode ? "transparent" : "white",
                      border: state.isFocused
                        ? "1px solid #80bdff"
                        : isDarkMode
                        ? "1px solid #495057"
                        : "1px solid #dee2e6", // Adjust the border color for focus
                      boxShadow: state.isFocused
                        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                        : "none", // Bootstrap's box shadow for focus
                      borderRadius: ".45rem",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                    }),
                    indicatorSeparator: (provided) => ({
                      ...provided,
                      display: "none", // Hide the indicator separator
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                      color: isDarkMode ? "#ffffff" : "#868686",
                    }),
                    clearIndicator: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "#868686", // Set clear icon color
                      // ":hover": {
                      //   color: isDarkMode ? "#34DBB4" : "#34DBB4", // Set hover color for clear icon
                      // },
                      cursor: "pointer",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "black",
                      backgroundColor: isDarkMode ? "#1f2023" : "white",
                      margin: "0", // Remove default margin
                      zIndex: "9999",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                      // Additional styles for placeholder
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "black",
                      backgroundColor: state.isHovered
                        ? "#80bdff"
                        : isDarkMode
                        ? "#1f2023"
                        : "white",
                      ":hover": {
                        backgroundColor: isDarkMode ? "#34DBB4" : "#34DBB4",
                      },
                    }),
                  }}
                /> */}
                  </>
                  
                  <MultiSelect
                    options={dealerships2}
                    className={`selectpicker w-100 ${
                      isDarkMode ? "reactMultiDark" : ""
                    }`}
                    value={selectedOption}
                    onChange={(selectedOptions) => {
                      localStorage.removeItem("eventsFilterData");
                      localStorage.removeItem("eventsFilterPostData");
                      localStorage.setItem(
                        "dealershipFilter",
                        selectedOptions.length === 0
                          ? null
                          : JSON.stringify(selectedOptions)
                      );
                      setCheckedFields([]);
                      // Create a local variable with the new value
                      const newSelectedOption = selectedOptions;
                      selectedOptionRef.current =
                        selectedOptions.length === 0 ? null : selectedOptions;

                      setSelectedOption(() => newSelectedOption); // Update state with selected options
                      setDealershipLabel(selectedOption?.label || null);
                      // // Extract values from selectedOptions
                      // const selectedValues = selectedOptions?.map(
                      //   (option) => option.value
                      // );

                      // // Pass the array of selected values to the required functions
                      // getDealershipFilterData(selectedValues);
                      // if (userType && internalUsers.includes(userType)) {
                      //   getDealershipFilterDataDealersPage([]); // Pass an empty array for resetting
                      // }
                      // getUsersByDealership([]); // Pass an empty array for resetting
                    }}
                    // disableSearch

                    // labelledBy={dealershipLabel ? dealershipLabel : translations["dropdown"].select[language]}
                    overrideStrings={{
                      selectSomeItems: dealershipLabel
                        ? dealershipLabel
                        : translations["dropdown"].select[language],
                    }}
                  />
                 
                  
                </div>
                <div
                  style={{ width: "250px" }}
                  className={
                    isDarkMode ? "statusDropdownDark" : "statusDropdown"
                  }
                >
                   <MultiSelect
                    options={provincesOptions}
                    className={`selectpicker w-100 ${isDarkMode ? "reactMultiDark" : ""}`}
                    value={selectedProvince}
                    onChange={(selectedOptions) => {
                      localStorage.setItem(
                        "provinceFilter",
                        selectedOptions.length === 0
                          ? null
                          : JSON.stringify(selectedOptions)
                      );

                      setSelectedProvince(selectedOptions);
         if (selectedOptions.length === 0) {
    setProvinceLabel(null); // reset to placeholder
  } else if (selectedOptions.length === 1) {
    setProvinceLabel(selectedOptions[0].label);
  } else {
    setProvinceLabel(`${selectedOptions.length} selected`);
  }
                    }}
                    overrideStrings={{
                      selectSomeItems: provinceLabel || "Select Province",
                    }}
                  />
                  </div>
               </>
              )}

              {(displayComponent === "dealership" ||
                displayComponent === "manage-users") && (
                <div style={{ width: "250px" }}>
                  <MultiSelect
                    options={dealerships3}
                    className={`selectpicker w-100 ${
                      isDarkMode ? "reactMultiDark" : ""
                    }`}
                    value={selectedOption}
                    onChange={(selectedOptions) => {
                      setSelectedOption(selectedOptions); // Update state with selected options

                      // Extract values from selectedOptions
                      const selectedValues = selectedOptions?.map(
                        (option) => option.value
                      );
                      localStorage.setItem(
                        "dealershipFilter",
                        selectedOptions.length === 0
                          ? null
                          : JSON.stringify(selectedOptions)
                      );
                      localStorage.removeItem("eventsFilterData");
                      setCheckedFields([]);
                      if (displayComponent === "dealership") {
                        getDealershipFilterData([]);
                        if (userType && internalUsers.includes(userType)) {
                          getDealershipFilterDataDealersPage(
                            selectedValues || []
                          );
                        }
                      } else if (displayComponent === "manage-users") {
                        getDealershipFilterData([]);
                        if (userType && internalUsers.includes(userType)) {
                          getDealershipFilterDataDealersPage([]);
                        }
                      } else {
                        getDealershipFilterData(selectedValues || [] , selectedProvince ? selectedProvince.map((option) => option.value) : []);
                        if (userType && internalUsers.includes(userType)) {
                          getDealershipFilterDataDealersPage([]);
                        }
                      }
                    }}
                    // disableSearch
                    labelledBy={translations["dropdown"].select[language]}
                  />
                  {/* <Select
                  className="w-100 selectpicker"
                  aria-labelledby="dealership-name-quick"
                  isClearable
                  options={dealerships3}
                  placeholder={translations["dropdown"].select[language]}
                  isSearchable={true}
                  // value={
                  //   (dealerships2 &&
                  //     dealerships2.length > 0 &&
                  //     dealerships2.find(
                  //       (option) => option.value === filterOption
                  //     )) || {
                  //     value: "",
                  //     label: translations["dropdown"].select[language],
                  //   }
                  // }
                  value={selectedOption} // Controlled value
                  onChange={(selectedOption) => {
                    setSelectedOption(selectedOption);
                    if (displayComponent === "dealership") {
                      getDealershipFilterData("");
                      getDealershipFilterDataDealersPage(
                        selectedOption ? selectedOption.value : ""
                      );
                    } else if (displayComponent === "manage-users") {
                      getDealershipFilterData("");
                      getDealershipFilterDataDealersPage("");
                    } else {
                      getDealershipFilterData(
                        selectedOption ? selectedOption.value : ""
                      );
                      getDealershipFilterDataDealersPage("");
                    }
                  }}
                  maxMenuHeight={"130px"}
                  styles={{
                    input: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                    }),
                    control: (provided, state) => ({
                      ...provided,
                      backgroundColor: isDarkMode ? "transparent" : "white",
                      border: state.isFocused
                        ? "1px solid #80bdff"
                        : isDarkMode
                        ? "1px solid #495057"
                        : "1px solid #dee2e6", // Adjust the border color for focus
                      boxShadow: state.isFocused
                        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                        : "none", // Bootstrap's box shadow for focus
                      borderRadius: ".45rem",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                    }),
                    indicatorSeparator: (provided) => ({
                      ...provided,
                      display: "none", // Hide the indicator separator
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                      color: isDarkMode ? "#ffffff" : "#868686",
                    }),
                    clearIndicator: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "#868686", // Set clear icon color
                      // ":hover": {
                      //   color: isDarkMode ? "#34DBB4" : "#34DBB4", // Set hover color for clear icon
                      // },
                      cursor: "pointer",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "black",
                      backgroundColor: isDarkMode ? "#1f2023" : "white",
                      margin: "0", // Remove default margin
                      zIndex: "9999",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                      // Additional styles for placeholder
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      color: isDarkMode ? "#ffffff" : "black",
                      backgroundColor: state.isHovered
                        ? "#80bdff"
                        : isDarkMode
                        ? "#1f2023"
                        : "white",
                      ":hover": {
                        backgroundColor: isDarkMode ? "#34DBB4" : "#34DBB4",
                      },
                    }),
                  }}
                /> */}
                </div>
              )}

              <DarkModeToggle
                onChange={setIsDarkMode}
                checked={isDarkMode}
                size={70}
                className="mx-2"
              />

              {/* <LanguageToggle /> */}
              <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  className="d-flex btn btn-primary align-items-center admin-btn"
                  onClick={() => {
                    setDisplayComponent((prev) => {
                      setPrevDisplay(prev);
                      return "user-profile";
                    });
                    window.history.pushState(
                      { id: "userProfile", randomData: window.Math.random() },
                      "title",
                      "?page=user-profile"
                    );
                  }}
                >
                  <i className="bi bi-person-circle me-2"></i>
                  {translations.topAndsidebar.profile[language]}
                </button>
                <button
                  style={{ marginBottom: 0 }}
                  className="btn btn-light navbar-toggler bi bi-list"
                  data-bs-target="#offcanvasmain"
                  data-bs-toggle="offcanvas"
                  aria-bs-controls="offcanvasmain"
                  type="button"
                ></button>
              </div>
            </div>
          )}
           
          {isMobile && (
            <div className="btn-group" role="group" aria-label="Basic example" style={{gap:'10px'}}>
           {!excludedComponents.includes(displayComponent) && (
            <>
                <div
                  style={{ width: "120px" }}
                  className={
                    isDarkMode ? "statusDropdownDark" : "statusDropdown"
                  }
                >
                  <MultiSelect
                    options={dealerships2}
                    className={`selectpicker w-100 ${
                      isDarkMode ? "reactMultiDark" : ""
                    }`}
                    value={selectedOption}
                    onChange={(selectedOptions) => {
                      localStorage.removeItem("eventsFilterData");
                      localStorage.removeItem("eventsFilterPostData");
                      localStorage.setItem(
                        "dealershipFilter",
                        selectedOptions.length === 0
                          ? null
                          : JSON.stringify(selectedOptions)
                      );
                      setCheckedFields([]);
                      // Create a local variable with the new value
                      const newSelectedOption = selectedOptions;
                      selectedOptionRef.current =
                        selectedOptions.length === 0 ? null : selectedOptions;

                      setSelectedOption(() => newSelectedOption); // Update state with selected options
                      setDealershipLabel(selectedOption?.label || null);
                     
                    }}
                    
                    overrideStrings={{
                      selectSomeItems: dealershipLabel
                        ? dealershipLabel
                        : translations["dropdown"].select[language],
                    }}
                  />
                </div>
                <div
                  style={{ width: "120px" }}
                  className={
                    isDarkMode ? "statusDropdownDark" : "statusDropdown"
                  }
                >
                   <MultiSelect
                    options={provincesOptions}
                    className={`selectpicker w-100 ${isDarkMode ? "reactMultiDark" : ""}`}
                    value={selectedProvince}
                    onChange={(selectedOptions) => {
                      localStorage.setItem(
                        "provinceFilter",
                        selectedOptions.length === 0
                          ? null
                          : JSON.stringify(selectedOptions)
                      );

                      if (selectedOptions.length === 0) {
    setProvinceLabel(null); // reset to placeholder
  } else if (selectedOptions.length === 1) {
    setProvinceLabel(selectedOptions[0].label);
  } else {
    setProvinceLabel(`${selectedOptions.length} selected`);
  }
                    }}
                    overrideStrings={{
                      selectSomeItems: provinceLabel || "Select Province",
                    }}
                  />
                  </div>
                  </>
              )}
              <button
                style={{
                  marginBottom: 0,
                  fontSize: "26px",
                  padding: "5px 10px",
                  borderRadius:'5px'
                }}
                className="btn btn-light navbar-toggler bi bi-list"
                data-bs-target="#offcanvasmain"
                data-bs-toggle="offcanvas"
                aria-bs-controls="offcanvasmain"
                type="button"
              ></button>
            </div>
          )}
        </div>
      </nav>
      <div
        style={{
          overflow: "hidden",
          paddingTop: 0,
          bottom: "auto",
        }}
        className={`offcanvas offcanvas-end offcanvas-sm h-100 ${
          isDarkMode ? "bg-dark" : "bg-body-tertiary"
        } `}
        tabindex="-1"
        id="offcanvasmain"
        data-bs-backdrop="true"
        aria-bs-labelledby="offcanvasmainLabel"
      >
        {/* <div className="offcanvas-header" style={{ paddingBottom: 0 }}>
          <a className="navbar-brand text-center" id="offcanvasExampleLabel">
            <img className="logo" src={logo} alt="Logo" height="35" />
          </a>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div> */}
        {/* <hr style={{ marginTop: 0 }} /> */}
        <div className="flex-column p-4 offcanvas-body">
          <div className="d-flex align-items-center justify-content-between">
            <a className="navbar-brand text-center" id="offcanvasExampleLabel">
              <img
                id="search-link-logo"
                className="p-1 w-100"
                src={isDarkMode ? logoDark : logo}
                alt="Logo"
                height="38"
              />
            </a>
            <button
              type="button"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              style={{
                background: "transparent",
                color: isDarkMode ? "white" : "black",
                border: "none",
                fontWeight: "400",
                fontSize: "18px",
              }}
            >
              X
            </button>
          </div>

          <ul className="flex-column nav gap-2 mt-4">
           {isMobile && (
  <li className="my-2">
    <div className="d-flex ">
      {/* Profile Button */}
      <button
        type="button"
        className="d-flex align-items-center justify-content-center btn btn-outline-primary"
        style={{
          // backgroundColor: isDarkMode ? "#1e1e2f" : "#ffffff",
          color: '#32DBB4',
          border: "1px solid #32DBB4",
         
          borderRadius: "0.5rem",
          padding: "0.375rem 0.4rem",
          minWidth: "85px",
          gap: "0.5rem",
          borderTopRightRadius:'0px',
          borderBottomRightRadius:'0px',
          borderRight:'none'
        }}
        fdprocessedid="dyv9n"
        data-bs-dismiss="offcanvas"
        onClick={() => {
          setDisplayComponent((prev) => {
            setPrevDisplay(prev);
            return "user-profile";
          });
          window.history.pushState(
            { id: "userProfile", randomData: Math.random() },
            "title",
            "?page=user-profile"
          );
        }}
      >
        {translations.topAndsidebar.profile[language]}
      </button>

      {/* Dark Mode Toggle */}
      <button
        type="button"
        className="d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: isDarkMode ? "#6c757d" : "#ffffff",
          // color: isDarkMode ? "#ffffff" : "#000000",
          border: "1px solid",
          borderColor: isDarkMode ? "#6c757d" : "#6c757d",
          borderRadius: "0.5rem",
          padding: "0.375rem 0.4rem",
          minWidth: "50px",
          justifyContent: "center",
          borderTopLeftRadius:'0px',
          borderBottomLeftRadius:'0px',
        }}
        fdprocessedid="dyv9n"
        data-bs-dismiss="offcanvas"
        onClick={() => setIsDarkMode(!isDarkMode)}
      >
        <i className={isDarkMode ? "bi bi-sun-fill" : "bi bi-moon"}></i>
      </button>
    </div>
  </li>
)}

           

            <li className="">
              <div className="d-grid gap-2">
                <button
                  type="button"
                  className="d-flex nav-link align-items-center admin-btn gap-1"
                  id="search-link"
                  fdprocessedid="dyv9n"
                  data-bs-dismiss="offcanvas"
                  onClick={() => {
                    setDisplayComponent((prev) => {
                      setPrevDisplay(prev);
                      return "events";
                    });
                    window.history.pushState(
                      { id: "gallery", randomData: window.Math.random() },
                      "title",
                      "?page=events"
                    );
                  }}
                  // style={{backgroundColor:"none"}}
                >
                  <i className="bi bi-search"></i>{" "}
                  {pageTranslations.events[language]}
                </button>
              </div>
            </li>

            {/* <li className="">
              <div className="d-grid gap-2">
                <button
                  type="button"
                  className="d-flex nav-link align-items-center admin-btn gap-1"
                  id="search-link"
                  fdprocessedid="dyv9n"
                  data-bs-dismiss="offcanvas"
                  onClick={() => {
                    setDisplayComponent((prev) => {
                      setPrevDisplay(prev);
                      return "forms";
                    });
                    window.history.pushState(
                      { id: "gallery", randomData: window.Math.random() },
                      "title",
                      "?page=forms"
                    );
                  }}
                  // style={{backgroundColor:"none"}}
                >
                  <i className="bi bi-file-earmark-diff"></i>{" "}
                  {pageTranslations.forms[language]}
                </button>
              </div>
            </li> */}

            {/* <li className="">
              <div className="d-grid gap-2">
                <button
                  type="button"
                  className="d-flex nav-link align-items-center admin-btn gap-1"
                  id="create-form-link"
                  fdprocessedid="v57r2v"
                  data-bs-dismiss="offcanvas"
                  onClick={() => {
                    setDisplayComponent((prev) => {
                      setPrevDisplay(prev);
                      return "create-event";
                    });
                    window.history.pushState(
                      { id: "gallery", randomData: window.Math.random() },
                      "title",
                      "/event-portal?page=create-event"
                    );
                  }}
                >
                  <i className="bi bi-file-earmark-plus"></i>{" "}
                  {pageTranslations.createevent[language]}
                </button>
              </div>
            </li> */}
            {userData &&
              userData.roles[0].permissions.some(
                (item) => item.name === "All Dealerships"
              ) && (
                <li className="">
                  <div className="d-grid gap-2">
                    <button
                      type="button"
                      className="d-flex nav-link align-items-center admin-btn gap-1"
                      id="add-dlr-link"
                      fdprocessedid="4u2e3"
                      Concession
                      data-bs-dismiss="offcanvas"
                      onClick={() => {
                        setDisplayComponent((prev) => {
                          setPrevDisplay(prev);
                          return "dealership";
                        });
                        window.history.pushState(
                          // { id: "gallery", randomData: window.Math.random() },
                          { prevState: "prev" },
                          "title",
                          "/event-portal?page=dealership"
                        );
                      }}
                    >
                      <i className="bi bi-shop-window"></i>{" "}
                      {pageTranslations.dealership[language]}{" "}
                      {/*<span className="badge bg-danger rounded-pill">NEW</span>*/}
                    </button>
                  </div>
                </li>
              )}
            {userData &&
              userData.roles[0].permissions.some(
                (item) => item.name === "All Users"
              ) && (
                <li className="">
                  <div className="d-grid gap-2">
                    {/* <Link to='/create-user' style={{ textDecoration: "none" }}> */}
                    <button
                      type="button"
                      className="d-flex nav-link align-items-center admin-btn gap-1"
                      id="create-user-link"
                      fdprocessedid="dyv9n"
                      data-bs-dismiss="offcanvas"
                      onClick={() => {
                        setDisplayComponent((prev) => {
                          setPrevDisplay(prev);
                          return "manage-users";
                        });
                        window.history.pushState(
                          { prevState: "prev" },
                          "title",
                          "/event-portal?page=manage-users"
                        );
                      }}
                    >
                      <i className="bi bi-people"></i>{" "}
                      {pageTranslations.manageUsers[language]}
                    </button>
                    {/* </Link> */}
                  </div>
                </li>
              )}
            {false && (
              <>
                {userData &&
                  userData.roles[0].permissions.some(
                    (item) => item.name === "Event Report"
                  ) && (
                    <li className="">
                      <div className="d-grid gap-2">
                        <button
                          type="button"
                          className="d-flex nav-link align-items-center admin-btn gap-1"
                          id="add-dlr-link"
                          fdprocessedid="4u2e3"
                          Concession
                          data-bs-dismiss="offcanvas"
                          onClick={() => {
                            setDisplayComponent((prev) => {
                              setPrevDisplay(prev);
                              return "view-event-report";
                            });
                            window.history.pushState(
                              {
                                id: "gallery",
                                randomData: window.Math.random(),
                              },
                              "title",
                              "/event-portal?page=view-event-report"
                              // "/event-portal?page=view-event-report&event_id=35"
                            );
                          }}
                        >
                          <i className="bi bi-file-earmark-bar-graph"></i>{" "}
                          {pageTranslations.eventReports[language]}{" "}
                          {/*<span className="badge bg-danger rounded-pill">NEW</span>*/}
                        </button>
                      </div>
                    </li>
                  )}
                {userData &&
                  userData.roles[0].permissions.some(
                    (item) => item.name === "Contract And Billing"
                  ) && (
                    <li className="">
                      <div className="d-grid gap-2">
                        <button
                          type="button"
                          className="d-flex nav-link align-items-center admin-btn gap-1"
                          id="add-dlr-link"
                          fdprocessedid="4u2e3"
                          Concession
                          data-bs-dismiss="offcanvas"
                          onClick={() => {
                            setDisplayComponent((prev) => {
                              setPrevDisplay(prev);
                              return "view-billing-report";
                            });
                            window.history.pushState(
                              {
                                id: "gallery",
                                randomData: window.Math.random(),
                              },
                              "title",
                              "/event-portal?page=view-billing-report"
                            );
                          }}
                        >
                          <i className="bi bi-file-earmark-bar-graph"></i>{" "}
                          {pageTranslations.billingReport[language]}{" "}
                          {/*<span className="badge bg-danger rounded-pill">NEW</span>*/}
                        </button>
                      </div>
                    </li>
                  )}{" "}
              </>
            )}
            {userData &&
              userData.roles[0].permissions.some(
                (item) => item.name === "Sales Report"
              ) && (
                <li className="">
                  <div className="d-grid gap-2">
                    <button
                      type="button"
                      className="d-flex nav-link align-items-center admin-btn gap-1"
                      id="add-dlr-link"
                      fdprocessedid="4u2e3"
                      Concession
                      data-bs-dismiss="offcanvas"
                      onClick={() => {
                        setDisplayComponent((prev) => {
                          setPrevDisplay(prev);
                          return "view-sales-report";
                        });
                        window.history.pushState(
                          {
                            id: "gallery",
                            randomData: window.Math.random(),
                          },
                          "title",
                          "/event-portal?page=view-sales-report"
                        );
                      }}
                    >
                      <i className="bi bi-receipt"></i>{" "}
                      {pageTranslations.salesReport[language]}{" "}
                      {/*<span className="badge bg-danger rounded-pill">NEW</span>*/}
                    </button>
                  </div>
                </li>
              )}

            {userType &&
              internalUsers.includes(userType) &&
              userType !== "Animator" &&
              userType !== "Agent" && (
                <li className="">
                  <div className="d-grid gap-2">
                    <button
                      type="button"
                      className="d-flex nav-link align-items-center admin-btn gap-1"
                      id="add-dlr-link"
                      fdprocessedid="4u2e3"
                      Concession
                      data-bs-dismiss="offcanvas"
                      onClick={() => {
                        setDisplayComponent((prev) => {
                          setPrevDisplay(prev);
                          return "status-report";
                        });
                        window.history.pushState(
                          {
                            id: "gallery",
                            randomData: window.Math.random(),
                          },
                          "title",
                          "/event-portal?page=status-report"
                        );
                      }}
                    >
                      <i className="bi bi-table"></i>{" "}
                      {pageTranslations.statusReport[language]}{" "}
                      {/*<span className="badge bg-danger rounded-pill">NEW</span>*/}
                    </button>
                  </div>
                </li>
              )}
            {userType &&
              internalUsers.includes(userType) &&
              userType !== "Animator" &&
              userType !== "Agent" && (
                <li className="">
                  <div className="d-grid gap-2">
                    <button
                      type="button"
                      className="d-flex nav-link align-items-center admin-btn gap-1"
                      id="add-dlr-link"
                      fdprocessedid="4u2e3"
                      Concession
                      data-bs-dismiss="offcanvas"
                      onClick={() => {
                        setDisplayComponent((prev) => {
                          setPrevDisplay(prev);
                          return "black-list";
                        });
                        window.history.pushState(
                          {
                            id: "gallery",
                            randomData: window.Math.random(),
                          },
                          "title",
                          "/event-portal?page=black-list"
                        );
                      }}
                    >
                      <i className="bi bi-card-list"></i>{" "}
                      {pageTranslations.blackList[language]}{" "}
                      {/*<span className="badge bg-danger rounded-pill">NEW</span>*/}
                    </button>
                  </div>
                </li>
              )}
            {/* {userType &&
              internalUsers.includes(userType) &&
              userType !== "Animator" &&
              userType !== "Agent" &&
              userType !== "Project Manager" &&
              userType !== "Representative" && (
                <li className="">
                  <div className="d-grid gap-2">
                    <button
                      type="button"
                      className="d-flex nav-link align-items-center admin-btn gap-1"
                      id="add-dlr-link"
                      fdprocessedid="4u2e3"
                      Concession
                      data-bs-dismiss="offcanvas"
                      onClick={() => {
                        setDisplayComponent((prev) => {
                          setPrevDisplay(prev);
                          return "agent-bonus-report";
                        });
                        window.history.pushState(
                          {
                            id: "gallery",
                            randomData: window.Math.random(),
                          },
                          "title",
                          "/event-portal?page=agent-bonus-report"
                        );
                      }}
                    >
                      <i className="bi bi-list-task"></i>{" "}
                      {pageTranslations.agentBonusReport[language]}{" "}
                  
                    </button>
                  </div>
                </li>
              )} */}
            {/* {userType &&
              internalUsers.includes(userType) &&
              userType !== "Animator" &&
              userType !== "Agent" &&
              userType !== "Project Manager" &&
              userType !== "Representative" && (
                <li className="">
                  <div className="d-grid gap-2">
                    <button
                      type="button"
                      className="d-flex nav-link align-items-center admin-btn gap-1"
                      id="add-dlr-link"
                      fdprocessedid="4u2e3"
                      Concession
                      data-bs-dismiss="offcanvas"
                      onClick={() => {
                        setDisplayComponent((prev) => {
                          setPrevDisplay(prev);
                          return "bonus-confirmation-report";
                        });
                        window.history.pushState(
                          {
                            id: "gallery",
                            randomData: window.Math.random(),
                          },
                          "title",
                          "/event-portal?page=bonus-confirmation-report"
                        );
                      }}
                    >
                      <i className="bi bi-list-columns-reverse"></i>{" "}
                      {pageTranslations.bonusConfirmationReport[language]}{" "}
                     
                    </button>
                  </div>
                </li>
              )} */}
            {/* <li className="nav-item">
              <div className="d-grid gap-2">
                <button
                  type="button"
                  className="nav-link admin-btn"
                  id="manage-notif-link"
                  fdprocessedid="3bt1kb"
                  data-bs-dismiss="offcanvas"
                  onClick={() => {
                    setDisplayComponent((prev) => {
                      setPrevDisplay(prev);
                      return "notifications";
                    });
                    window.history.pushState(
                      {
                        id: "notif management",
                        randomData: window.Math.random(),
                      },
                      "title",
                      "/event-portal?page=notifications"
                    );
                  }}
                >
                  <i className="bi bi-bell"></i>{" "}
                  {pageTranslations.manageNotification[language]}{" "}
                  <span className="badge bg-danger rounded-pill">NEW</span>
                </button>
              </div>
            </li> */}

            {userType && externalUsers.includes(userType) && (
              <li className="">
                <div className="d-grid gap-2">
                  {/* <Link to='/create-user' style={{ textDecoration: "none" }}> */}
                  <button
                    type="button"
                    className="d-flex nav-link align-items-center admin-btn gap-1"
                    id="create-user-link"
                    fdprocessedid="dyv9n"
                    data-bs-dismiss="offcanvas"
                    onClick={() => {
                      setDisplayComponent((prev) => {
                        setPrevDisplay(prev);
                        return "view-submissons";
                      });
                      window.history.pushState(
                        { prevState: "prev" },
                        "title",
                        "/event-portal?page=view-submissons"
                      );
                    }}
                  >
                    <i className="bi bi-people"></i>{" "}
                    {pageTranslations.viewClientSubmissions[language]}
                  </button>
                  {/* </Link> */}
                </div>
              </li>
            )}
             {userType &&
              internalUsers.includes(userType) &&
              userType !== "Animator" &&
              userType !== "Agent" && (
              <li className="">
                <div className="d-grid gap-2">
                  {/* <Link to='/create-user' style={{ textDecoration: "none" }}> */}
                  <button
                    type="button"
                    className="d-flex nav-link align-items-center admin-btn gap-1"
                    id="create-user-link"
                    fdprocessedid="dyv9n"
                    data-bs-dismiss="offcanvas"
                    onClick={() => {
                      setDisplayComponent((prev) => {
                        setPrevDisplay(prev);
                        return "reports";
                      });
                      window.history.pushState(
                        { prevState: "prev" },
                        "title",
                        "/event-portal?page=reports"
                      );
                    }}
                  >
                    <i className="bi bi-file-earmark-bar-graph"></i>{" "}
                    {translations.viewEventReport.global_title[language]}
                  </button>
                  {/* </Link> */}
                </div>
              </li>
            )}
            {/* <li className="">
              <div className="d-grid gap-2">
                

                <button
                  type="button"
                  className="d-flex btn nav-link align-items-center admin-btn gap-1"
                  id="manage-notif-link"
                  data-bs-toggle="modal"
                  data-bs-target="#changePasswordModal"
                  fdprocessedid="3bt1kb"
                  data-bs-dismiss="offcanvas"
                ><i class="bi bi-lock"></i>
                  {pageTranslations.changePassword[language]}
                </button>
                
              </div>
            </li> */}
            <li className="">
              <div className="d-grid gap-2">
                <hr
                  className=""
                  style={{
                    border: isDarkMode
                      ? "1px solid #ffffff"
                      : "1px solid #000000",
                    marginBlock: "2px",
                  }}
                />
                <button
                  type="button"
                  className="d-flex btn nav-link align-items-center text-black gap-1"
                  id="manage-notif-link"
                  fdprocessedid="3bt1kb"
                  data-bs-dismiss="offcanvas"
                  onClick={handleLogout}
                  style={{
                    backgroundColor: "#DC3444",
                    fontSize: "1rem",
                    borderRadius: "0.375rem",
                    padding: "0.375rem 0.75rem",
                    textDecoration: "none",
                  }}
                >
                  <i className="bi bi-box-arrow-left"></i>{" "}
                  {pageTranslations.logout[language]}{" "}
                </button>
              </div>
            </li>
          </ul>
          {/* <div
            style={{
              width: 350,
              paddingTop: 30,
              margin: "0 auto",
              opacity: 0.3,
              filter: "alpha(opacity=30), blur(5px)",
            }}
          >
            <img style={{ width: 350 }} src={people} alt="People working" />
          </div> */}
        </div>
        <div className="text-black text-center w-75 mx-auto offcanvas-footer">
          <p className="fw-lighter smalltext">
            {translations.footerTxt1[language]}© {currentYear} FIDGI
            Communications. {translations.footerTxt2[language]}
          </p>
        </div>
      </div>
      <ModalAdminQuickAdd
        setDisplayComponent={setDisplayComponent}
        setEventTrigger={setEventTrigger}
        dealerships={dealerships}
        setDealerTrigger={setDealerTrigger}
        isDarkMode={isDarkMode}
      />
      <ChangePasswordModal setIsLoading={setIsLoading} />
    </div>
  );
};

export default AdminNav;
